import { GetterTree } from "vuex";
import { IANumbersState } from ".";
import { IRootState } from "@/store/types";
import { IANumberAssignment } from "@/models/anumberassignments";
import { IANumberGroup } from "@/models/anumbergroup";
import { IANumber } from "@/models/anumber";

export const getters: GetterTree<IANumbersState, IRootState> = {
    aNumberAssignmentsList(state): IANumber[] | null {
        return state.aNumberAssignmentsList;
    },
    aNumberGroupsList(state): IANumberGroup[] | null {
        return state.aNumberGroupsList;
    },
    selectedANumberAssignment(state): IANumberAssignment | null {
        return state.selectedANumberAssignment;
    },
    selectedANumberGroup(state): IANumberGroup | null {
        return state.selectedANumberGroup;
    },
};
